/*
 * types/services/dr2am.tasks.preferences.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceDeletePreferenceResponse model module.
 * @module model/ServiceDeletePreferenceResponse
 * @version version not set
 */
export class ServiceDeletePreferenceResponse {
  /**
   * Constructs a new <code>ServiceDeletePreferenceResponse</code>.
   * @alias module:model/ServiceDeletePreferenceResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceDeletePreferenceResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceDeletePreferenceResponse} obj Optional instance to populate.
   * @return {module:model/ServiceDeletePreferenceResponse} The populated <code>ServiceDeletePreferenceResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceDeletePreferenceResponse();
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbResponseState} state
 */
ServiceDeletePreferenceResponse.prototype.state = undefined;


